
import React from 'react'
import { BottomSheet } from 'react-spring-bottom-sheet'
import 'react-spring-bottom-sheet/dist/style.css'
import './SaleTerminatingSessions.css'
import { SetSalePendingVerificationBSh } from './../app/Home'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect } from 'react'
const SalePendingVerification = () => {
    const dispatch = useDispatch()
    const SalePendingVerificationBSh = useSelector((state) => state.Home.SalePendingVerificationBSh)

    const onDismiss = () => {
        setTimeout(() => {
        dispatch(SetSalePendingVerificationBSh(false))
    }, 300);
    }
  
    
  return (
    <BottomSheet onDismiss={onDismiss} open={SalePendingVerificationBSh}>
    <div className='SaleTerminatingSessions'>
        <div className='SaleTerminatingSessionsTitle'>
        Pending verification
        </div>
        <div className='SaleTerminatingSessionsDes'>
        Please wait <b>24 hours</b> for the coins to be credited to your account after our review
        </div>
       
        <div className='SaleTerminatingSessionsFooter'>
      
            <button className='TerminatingSessionsButton' onClick={()=> dispatch(SetSalePendingVerificationBSh(false))}>
                OK
            </button>
           
        </div>
    </div>
</BottomSheet>
  )
}

export default SalePendingVerification